"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimulatorExposureResource = void 0;
const Custom_1 = __importDefault(require("../decorators/Custom"));
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../Resource"));
class SimulatorExposureResource extends Resource_1.default {
}
exports.SimulatorExposureResource = SimulatorExposureResource;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(80),
    __metadata("design:type", String)
], SimulatorExposureResource.prototype, "label", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(1),
    __metadata("design:type", Number)
], SimulatorExposureResource.prototype, "weight", void 0);
class SimulatorDataResource extends Resource_1.default {
}
exports.default = SimulatorDataResource;
__decorate([
    (0, Custom_1.default)((entries) => Array.isArray(entries) &&
        entries.every((e) => e && typeof e.label === "string" && e.label.trim().length > 0) &&
        new Set(entries.map((e) => e.label)).size === entries.length &&
        entries.reduce((sum, e) => sum + e.weight, 0) <= 1.000001, { message: "simulatorInvalidExposure" }),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMaxSize)(100),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => SimulatorExposureResource),
    __metadata("design:type", Array)
], SimulatorDataResource.prototype, "geography", void 0);
__decorate([
    (0, Custom_1.default)((entries) => Array.isArray(entries) &&
        entries.every((e) => e && typeof e.label === "string" && e.label.trim().length > 0) &&
        new Set(entries.map((e) => e.label)).size === entries.length &&
        entries.reduce((sum, e) => sum + e.weight, 0) <= 1.000001, { message: "simulatorInvalidExposure" }),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMaxSize)(100),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => SimulatorExposureResource),
    __metadata("design:type", Array)
], SimulatorDataResource.prototype, "sectors", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Object)
], SimulatorDataResource.prototype, "reconstitutionValue", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(1),
    __metadata("design:type", Object)
], SimulatorDataResource.prototype, "ongoingFees", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(1),
    __metadata("design:type", Object)
], SimulatorDataResource.prototype, "transactionFees", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100),
    __metadata("design:type", String)
], SimulatorDataResource.prototype, "sourceId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(30),
    __metadata("design:type", String)
], SimulatorDataResource.prototype, "sourceDate", void 0);
